import React, { forwardRef } from "react";
import "./RadioButton.css";

const RadioButton = forwardRef(
  ({ width, height, borderRadius, text, value, checked, disabled, name, onChange, ...rest }, ref) => (
    <div className="radio-wrapper">
      <input
        id={value}
        value={value}
        type="radio"
        name={name}
        ref={ref}
        style={{ width, height, borderRadius }}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
        {...rest}
      />
      <label htmlFor={value} className={`form-control ${disabled ? "disabled-text" : ""}`}>
        {text}
      </label>
    </div>
  )
);

export default RadioButton;
